import { useEffect } from 'react';
import { useTrackVirtualPageView } from 'renderer/hooks/useTrackVirtualPageView';

const PageViewTrackerEvent = () => {
  const trackVirtualPageView = useTrackVirtualPageView();

  useEffect(() => {
    trackVirtualPageView();
  }, [trackVirtualPageView]);

  return null;
};

export default PageViewTrackerEvent;
